export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <img src="/icon.png" alt="" className="brand-mark" width={28} height={28} />
          <span>
            Viridian <span className="brand-name">Cloud Partners</span>
          </span>
        </div>
        <nav className="footer-links" aria-label="Footer">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
        <p className="footer-meta">© {year} Viridian Cloud Partners</p>
      </div>
    </footer>
  );
}
